<h1 mat-dialog-title>Are you sure?</h1>
<div mat-dialog-content>
  <p>Are you sure you want to perform this action?</p>
  <p *ngIf="data && data.text">{{data.text}}</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="remove-button" [mat-dialog-close]="false">No</button>
  <button mat-raised-button [mat-dialog-close]="true" class="add-button" cdkFocusInitial>Yes</button>
</div>